import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
import { GUARANTEE_DAYS, PRICE } from '../data/config';
const POINTS = ['Pago único con Mercado Pago, sin suscripción', 'Acceso inmediato vía mail a todo el material', 'Acceso a la comunidad de clientes VIP', `Garantía de devolución dentro de los ${GUARANTEE_DAYS} días`];
export function FinalOffer() {
  return <Section className="bg-cream-50" data-id="element-144" data-mp="1qcqnm32bj50x">
      <div className="rounded-[2rem] border border-ink-950/10 bg-ink-950 p-7 text-center sm:p-10" data-id="element-145" data-mp="1lfrspiatyu1o">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-146" data-mp="2044r0lxe4ozc">Paquete completo</p>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-147" data-mp="1v5jsqs1p8fdj">
          Libro principal + 5 bonos de regalo
        </h2>
        <p className="mt-8 text-4xl font-extrabold tracking-tight text-white sm:text-5xl" data-id="element-148" data-mp="292zys2g3274r">{PRICE}</p>
        <p className="mt-3 text-xs font-semibold uppercase tracking-wide text-white/50" data-id="element-149" data-mp="243wsyfsa3wvq">Pago único · Acceso de por vida</p>
        <div className="mt-8" data-id="element-150" data-mp="6ojvjinrf9hp">
          <CTAButton className="items-center" note="Pago en pesos argentinos." data-id="element-151" data-mp="6nqm29xf25vv" />
        </div>
        <ul className="mx-auto mt-8 grid max-w-2xl gap-3 text-left sm:grid-cols-2" data-id="element-152" data-mp="bnd6p4fkqoep">
          {POINTS.map(point => <li key={point} className="flex items-start gap-3 text-sm leading-relaxed text-white/70" data-id="element-153" data-mp="gnhdu3ule6s9">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-154" data-mp="knrvwevnsnnh" />
              {point}
            </li>)}
        </ul>
      </div>
    </Section>;
}